import { Container, Text } from "pixi.js";
import { DefaultTextStyle } from "./MonBaseContent";
import { MonPaymentProcessingLoader } from "./MonPaymentProcessingLoader";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class MonPaymentProcessingContainer extends Container {
    private static readonly DESCRIPTION_TEXT = "Transaction In Progress. Once Complete,\nWe’ll Notify You In The Game News Section,\nAnd In Your In-Game Wallet.";

    private readonly commonResources: CommonResourcesPackage;

    private descriptionText: Text;
    private processingPaymentLoader: MonPaymentProcessingLoader;

    public constructor(
        commonResources: CommonResourcesPackage,
    ) {
        super();
        this.commonResources = commonResources;
        this.build();
        this.layout();
        this.processingPaymentLoader.show();
    }

    private build(): void {
        this.processingPaymentLoader = new MonPaymentProcessingLoader(this.commonResources);
        this.descriptionText = new Text(MonPaymentProcessingContainer.DESCRIPTION_TEXT, new DefaultTextStyle());
        this.descriptionText.style.align = "center";
        this.descriptionText.style.fontSize = 36;
        this.descriptionText.style.letterSpacing = 3;
        this.descriptionText.style.leading = 3.5;

        this.addChild(
            this.processingPaymentLoader,
            this.descriptionText
        );
    }

    private layout(): void {
        this.processingPaymentLoader.scale.set(0.75);
        this.descriptionText.position.set(0, 85);
        this.processingPaymentLoader.position.set(this.descriptionText.width * 0.5 - 60, 0);
    }
}
